var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"footer_mail"},[_vm._v("联系邮箱：gysxtbx.list@homeinns.com")]),_vm._v(" "),_c('p',{staticClass:"footer_copyright"},[_vm._v("版权所有 © 2016 Homeinns Co.,Ltd All Rights Reserved. 和美酒店管理（上海）有限公司 沪ICP备15017896号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6757e6c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GysFooter.vue
// module id = null
// module chunks = 